import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import formVisuals from '@App/components/QuestionFormVisuals/question-form-visuals';
import './question-progress.css';

const QUESTION_IDS = Object.keys(formVisuals);

function QuestionProgress({ questionId }) {
  const currentIndex = QUESTION_IDS.indexOf(questionId);
  const currentVisual = formVisuals[questionId];
  const totalQuestions = QUESTION_IDS.length;

  return (
    <nav
      className="question-progress"
      aria-label="Question progress"
      style={{
        '--progress-accent': currentVisual.accent,
        '--progress-width': totalQuestions > 1
          ? `calc(17px + ((100% - 34px) * ${currentIndex / (totalQuestions - 1)}))`
          : '17px',
      }}
    >
      <span className="question-progress__count">
        {currentIndex + 1}
        {' '}
        /
        {' '}
        {totalQuestions}
      </span>
      <ol className="question-progress__list">
        {QUESTION_IDS.map((id, index) => {
          const visual = formVisuals[id];
          const isCurrent = id === questionId;
          const isComplete = index < currentIndex;

          return (
            <li
              className={`question-progress__item${isCurrent ? ' question-progress__item--current' : ''}${isComplete ? ' question-progress__item--complete' : ''}`}
              key={id}
            >
              <span
                className="question-progress__symbol"
                style={{
                  '--question-accent': visual.accent,
                  '--icon-offset-x': `${visual.iconOffsetX || 0}px`,
                }}
                aria-current={isCurrent ? 'step' : undefined}
                aria-label={`Question ${index + 1} of ${totalQuestions}`}
              >
                <FontAwesomeIcon icon={visual.icon} fixedWidth />
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default QuestionProgress;